'use strict';

import dispatcher from '../dispatcher';
import loaderStore from '../navigation/loader.store';
const skrollr = require('../skrollr');


let instance;
let initialized = false;



function _handleMutate() {
  // let mobile = e.width < 740;

  if (!initialized) {
    instance = skrollr.init({
      forceHeight: false,
      smoothScrolling: true,
      smoothScrollingDuration: 1200,
      mobileCheck: function () {
        return false;
      }
    });
    initialized = true;
  } else {
    instance.refresh();
    // setTimeout(function () {
    //   // var evt = document.createEvent('UIEvents');
    //   // evt.initUIEvent('scroll', true, false, window, 0);
    //   // window.dispatchEvent(evt);
    //   instance.refresh();
    // }, 1500);
  }
}


function init() {
  _handleMutate();

  dispatcher.subscribe((e) => {
    if (e.type === 'mutate') _handleMutate();
  });

  loaderStore.eventEmitter.subscribe((e) => {
    if (e.type === 'load-animation-play' && e.loadAnimation === 'end-complete') _handleMutate();
  });
}

export default {
  init: init
}